import { motion } from "motion/react"

import { useLetter, useModalStore } from "@/store"
import { Modal } from "../Modal"

import styles from "./index.module.scss"

export const LetterModal: React.FC = () => {
    const open = useModalStore((state) => state.letterOpen)
    const onCancel = useModalStore((state) => state.closeLetter)

    const letter = useLetter()

    if (!letter) return null

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            showCancelBtn={false}
            showOkBtn={false}
            size="letter"
            contentClassName={styles.letter}
            closeButtonClassName={styles.close}
        >
            <div className={styles.content}>
                <div className={styles.to}>{letter.to}</div>
                {letter.contents.map((item, index) => (
                    <div key={index} className={styles.page}>
                        {item}
                    </div>
                ))}
                <div
                    className={styles.sign}
                    style={{ backgroundImage: `url(${letter.signature})` }}
                />
                <motion.div
                    className={styles.decorations}
                    initial={{ opacity: 0, y: -60, rotate: -8 }}
                    animate={{ opacity: 1, y: 0, rotate: 0 }}
                    transition={{
                        duration: 0.7,
                        delay: 0.2,
                        ease: [0.25, 0.46, 0.45, 0.94],
                    }}
                />
            </div>
        </Modal>
    )
}
